module.exports = __webpack_public_path__ + "static/media/v_push-services-pa3.ec5e21a9.png";